export default {
  data: () => ({
    quick_alert: {
      title: `Notice`,
      message: ``,
      variant: `info`,
      showCancel: false,
      confirmText: `Confirm`,
      confirmIcon: null,
      cancelText: `Cancel`,
    },
  }),
  methods: {
    quickAlert(options, scope) {
      this.quick_alert = {
        ...this.quick_alert,
        ...options,
      };
      return this.fireModal(`quick-alert-modal-${scope || `global`}`);
    },
  },
};
